
namespace GeniuzPOS.AdvPromo {

    @Serenity.Decorators.registerClass()
    export class Adv05ItemDetailsDialog extends Serenity.EntityDialog<Adv05ItemDetailsRow, any> {
        protected getFormKey() { return Adv05ItemDetailsForm.formKey; }
        protected getIdProperty() { return Adv05ItemDetailsRow.idProperty; }
        protected getLocalTextPrefix() { return Adv05ItemDetailsRow.localTextPrefix; }
        protected getNameProperty() { return Adv05ItemDetailsRow.nameProperty; }
        protected getService() { return Adv05ItemDetailsService.baseUrl; }
        protected getDeletePermission() { return Adv05ItemDetailsRow.deletePermission; }
        protected getInsertPermission() { return Adv05ItemDetailsRow.insertPermission; }
        protected getUpdatePermission() { return Adv05ItemDetailsRow.updatePermission; }

        protected form = new Adv05ItemDetailsForm(this.idPrefix);

    }
}